import { StyledFlex } from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { AiAssistantMainMenuTileItemSummaryModalField } from './AiAssistantMainMenuTileItemSummaryModalField';
import {
   AiAssistantMainMenuTileItemSummaryFormBean,
   AiAssistantMainMenuTileItemSummaryFormController,
   AiAssistantMainMenuTileItemSummaryFormInitializer,
} from './AiAssistantMainMenuTileItemSummaryForm.types';

const t = translationKeys.mainMenuTileItem.summaryModal;

type AiAssistantMainMenuTileItemSummaryFormRenderProps = Pick<
   AiAssistantMainMenuTileItemSummaryFormController,
   'handleSubmit'
>;

type AiAssistantMainMenuTileItemSummaryFormProps = {
   initializer: AiAssistantMainMenuTileItemSummaryFormInitializer;
   children: (renderProps: AiAssistantMainMenuTileItemSummaryFormRenderProps) => JSX.Element;
};

export const AiAssistantMainMenuTileItemSummaryForm = (
   props: AiAssistantMainMenuTileItemSummaryFormProps
): JSX.Element => {
   const { register, handleSubmit } = useFormController<AiAssistantMainMenuTileItemSummaryFormBean>(
      props.initializer()
   );

   return (
      <>
         <StyledFlex direction={'column'} gap={16}>
            <AiAssistantMainMenuTileItemSummaryModalField
               controller={register('interview')}
               transferController={register('transferInterview')}
               redactionField={'INTERVIEW'}
               label={t.fieldInterview}
               testId={'summaryInterview'}
            />
            <AiAssistantMainMenuTileItemSummaryModalField
               controller={register('examination')}
               transferController={register('transferExamination')}
               redactionField={'EXAMINATION'}
               label={t.fieldExamination}
               testId={'summaryExamination'}
            />
            <AiAssistantMainMenuTileItemSummaryModalField
               controller={register('recommendations')}
               transferController={register('transferRecommendations')}
               redactionField={'RECOMMENDATIONS'}
               label={t.fieldRecommendations}
               testId={'summaryRecommendations'}
            />
         </StyledFlex>

         {props.children({ handleSubmit: handleSubmit })}
      </>
   );
};
